// Fallback UUID generator if the crypto library is not available.
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function randomUUID(): string {

  if(self.crypto && self.crypto.randomUUID)
    return self.crypto.randomUUID()

  return generateUUID()
}

let sessionId = sessionStorage.getItem("biskoui__sessionId")
if(!sessionId) {
  sessionId = randomUUID()
  sessionStorage.setItem("biskoui__sessionId", sessionId)
}

// We set a global session ID available for the lifetime of this session. The session includes page reload in the same
// tab. The goal is to have an ephemeral identifier to group together multiple recorded events, but without any way
// to link it to personal data as this will expire as soon as the user closes the tab. The session storage is good enough
// to survives multiple page reload and following links within the website.
// It's actually possible that session storage is a bit too strong for this, as a user that always keeps the tab open will
// still have the same session, but at the same time, that's interesting data to be able to still link the actions.
export const SESSION_ID: string = sessionId

interface BiskouiSettings {
  // The clientId is the Domain Name ID.
  clientId: string;

  // This is an advanced/dev settings that let the user test the banner without actually showing it to the users.
  // Note that the banner will do everything it usually do in terms of setting local storage and contacting the
  // backend, it will just not render.
  hidden?: boolean;

  // This is set automatically by the WordPress plugin. If true, it means this snippet was injected
  // by the WordPress plugin. The main use case for this is to block the usage in case it was set by
  // a domain without the appropriate subscription tier. Could also be used to record statistics.
  configuredByWordPress?: boolean;
}

export const BISKOUI_SETTINGS: BiskouiSettings = (window as any).biskouiSettings;
